import { ContentModal } from 'features/modals';
import { Outlet } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';

export const AuthLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as {
    backgroundLocation?: Location;
  };

  return (
    <ContentModal isOpen size={{ base: 'full', lg: '5xl' }} bodyProps={{ minH: '90vh' }} onClose={() => navigate(state.backgroundLocation!, { replace: true })}>
      <Outlet />
    </ContentModal>
  )
}